import React, { useEffect } from 'react';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { propTypes } from '../../util/types';

import SectionHero from './sections/SectionHero/SectionHero';
import SectionPurchases from './sections/SectionPurchases/SectionPurchases';
import SectionHowItWorks from './sections/SectionHowItWorks/SectionHowItWorks';
import SectionDisplays from './sections/SectionDisplays/SectionDisplays';
import SectionBrand from './sections/SectionBrand/SectionBrand';
import SectionCrafting from './sections/SectionCrafting/SectionCrafting';
import SectionRegister from './sections/SectionRegister/SectionRegister';
import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import PageBuilder from '../PageBuilder/PageBuilder';
import { camelize } from '../../util/string';
import { ASSET_NAME } from './LandingPage.duck';
import FallbackPage from './FallbackPage';

export const LandingPageComponent = props => {
  const {
    isAuthenticated,
    currentUser,
    scrollingDisabled,
    pageAssetsData,
    inProgress,
    error
  } = props

  // useEffect(() => {
  //   if (!isAuthenticated) {
  //     window.location.href = '/p/landing-clients';
  //   }
  // }, [isAuthenticated, currentUser]);

  return (
    <PageBuilder
      pageAssetsData={pageAssetsData?.[camelize(ASSET_NAME)]?.data}
      inProgress={inProgress}
      error={error}
      fallbackPage={<FallbackPage error={error} />}
    />
    // <Page
    //   scrollingDisabled={scrollingDisabled}
    // >
    //   <LayoutSingleColumn
    //     topbar={<TopbarContainer />}
    //     footer={<FooterContainer />}
    //   >
    //     <SectionHero />
    //     <SectionPurchases />
    //     <SectionHowItWorks />
    //     <SectionDisplays />
    //     <SectionBrand />
    //     <SectionRegister />
    //     <SectionCrafting />
    //   </LayoutSingleColumn>
    // </Page>
  );
};

LandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { isAuthenticated } = state.auth;
  const { currentUser } = state.user;
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};

  return {
    isAuthenticated,
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
    pageAssetsData,
    inProgress,
    error
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(connect(mapStateToProps))(LandingPageComponent);

export default LandingPage;
